import { useLang } from '../lib/useLang'

export default function Approach() {
  const { t } = useLang()
  const blocks = t('lp.approach.blocks') || []
  return (
    <section className='hairline-bottom'>
      <div className='mx-auto max-w-6xl px-6 lg:px-10 py-20 md:py-28'>
        <div className='mb-14 md:mb-16 max-w-4xl'>
          <div data-reveal className='label-eyebrow mb-8'>{t('lp.approach.eyebrow')}</div>
          <h2
            data-reveal
            className='headline-display text-3xl md:text-5xl lg:text-[3.4rem]'
          >
            {t('lp.approach.title')}
          </h2>
          <p
            data-reveal
            className='headline-display text-xl md:text-2xl lg:text-[1.6rem] text-muted mt-3'
          >
            {t('lp.approach.subtitle')}
          </p>
        </div>

        <div className='reality-grid'>
          {(Array.isArray(blocks) ? blocks : []).map((b, i) => (
            <div
              key={b.idx}
              data-reveal
              className='reality-block'
              style={{ transitionDelay: `${i * 0.1}s` }}
            >
              <div className='reality-block-head'>
                <span className='reality-idx mono'>/{b.idx}</span>
                <span className='reality-label'>{b.label}</span>
              </div>
              <h3 className='reality-title'>{b.title}</h3>
              <p className='reality-body'>{b.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
